import { useEffect, useState } from "react"
import axios from "axios"

const useNexmartCartRetailers = (cartItems, fetchRetailers = false) => {
  const [retailers, setRetailers] = useState(null)
  const [hasRetailers, setHasRetailers] = useState(undefined)

  function generateParams(items) {
    return items.reduce((params, item, index) => {
      const pidKey = `pid[${index}]`
      const qtKey = `qt[${index}]`

      params[pidKey] = item.externalKey
      params[qtKey] = item.quantity

      return params
    }, {})
  }

  useEffect(() => {
    if (fetchRetailers === true && cartItems.length > 0) {
      const specificParams = generateParams(cartItems)
      axios
        .get(process.env.NEXMART_API_URL, {
          auth: {
            username: process.env.NEXMART_USERNAME,
            password: process.env.NEXMART_PASSWORD,
          },
          params: {
            services: "cart",
            supplier: process.env.NEXMART_SUPPLIER,
            ...specificParams,
          },
        })
        .then((res) => {
          setRetailers(res.data.retailers)
          if (res.data.retailers && res.data.retailers.length > 0) {
            setHasRetailers(true)
          } else {
            setHasRetailers(false)
          }
        })
      return () => {
        setRetailers(null)
        setHasRetailers(false)
      }
    }
    if (fetchRetailers === false) {
      setRetailers(null)
      setHasRetailers(undefined)
    }
  }, [cartItems, fetchRetailers])

  return [hasRetailers, retailers]
}

export default useNexmartCartRetailers
